import axios from "axios";

const instance = axios.create({
  // baseURL: "http://localhost:1012/api/v1/",
  baseURL: "https://admin.zzlawfirm.mn/api/",
});

instance.defaults.withCredentials = true;

export default instance;
